module.exports = __webpack_public_path__ + "static/media/Landing_3.7e0d46f1.png";